/**
 * The chat's reply when a turn fails, so the failure shows in the
 * conversation instead of only in the console.
 *
 * @param {Error|undefined} error
 * @returns {string}
 */
export const chatErrorMessage = (error) =>
  error?.message
    ? `Something went wrong: ${error.message}`
    : 'Something went wrong.';
